var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgAteamLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 20,
    viewBox: "0 0 116 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 1.3437C12.4834 0.355531 11.2745 -0.0196046 10.3009 0.505817C9.3273 1.03124 8.9577 2.25825 9.47536 3.24642L17.6885 18.9244C18.2061 19.9126 19.415 20.2878 20.3886 19.7623C21.3622 19.2369 21.7318 18.0099 21.2142 17.0217L13.001 1.3437Z",
    fill: "url(#paint0_linear_3406_6502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.927 3.24649C13.4446 2.25832 13.075 1.0313 12.1014 0.505883C11.1278 -0.0195386 9.91895 0.355597 9.40128 1.34377L5.71458 8.38132C6.54431 9.55257 7.72213 10.328 9.0158 10.7125L12.927 3.24649Z",
    fill: "url(#paint1_linear_3406_6502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61137 15.3023C5.36567 14.8175 4.1997 14.1202 3.18442 13.2112L1.18817 17.0218C0.670504 18.01 1.0401 19.237 2.01369 19.7624C2.98728 20.2878 4.19618 19.9127 4.71385 18.9245L6.61137 15.3023Z",
    fill: "url(#paint2_linear_3406_6502)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0649 11.2491C9.19104 12.3547 4.41086 10.2797 3.98671 4.94518C3.89801 3.82963 2.93513 2.99827 1.83604 3.0883C0.736959 3.17833 -0.0821222 4.15564 0.00657493 5.27119C0.691222 13.8821 8.79843 17.1287 14.9863 14.9168L13.0649 11.2491Z",
    fill: "url(#paint3_linear_3406_6502)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2409 12.1034C20.7584 10.4293 21.7978 8.15065 22.0172 5.26404C22.102 4.14818 21.2795 3.17382 20.1801 3.08774C19.0807 3.00166 18.1207 3.83646 18.0359 4.95232C17.9441 6.16 17.6219 7.20271 17.1329 8.07949L19.2409 12.1034Z",
    fill: "url(#paint4_linear_3406_6502)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2921 19.8092C29.9153 19.8092 27.8262 18.0955 27.8262 15.2199C27.8262 12.5477 29.6291 10.7469 33.3779 10.1369L37.6991 9.43982V9.00413C37.6991 7.81325 36.6975 6.88379 35.095 6.88379C33.5496 6.88379 32.3191 7.81325 31.804 9.20745L28.37 7.55184C29.2857 4.90868 31.9757 3.25307 35.2953 3.25307C39.2444 3.25307 41.9917 5.60578 41.9917 9.00413V19.4606H37.9853V17.9793C36.7547 19.2282 35.2667 19.8092 33.2921 19.8092ZM32.2619 15.0747C32.2619 16.0623 33.0631 16.6141 34.1506 16.6141C36.2683 16.6141 37.6991 15.0747 37.6991 13.1286V12.6348L34.1506 13.2739C32.9201 13.5062 32.2619 14.029 32.2619 15.0747Z",
    fill: "url(#paint5_linear_3406_6502)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2557 17.2315C49.2557 18.6865 48.0937 19.8659 46.6602 19.8659C45.2268 19.8659 44.0647 18.6865 44.0647 17.2315C44.0647 15.7766 45.2268 14.5972 46.6602 14.5972C48.0937 14.5972 49.2557 15.7766 49.2557 17.2315Z",
    fill: "url(#paint6_linear_3406_6502)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6429 19.6349C52.8655 19.6349 50.6906 17.4565 50.6906 13.7386V7.37762H48.0578V3.60167H48.2009C49.8035 3.60167 50.6906 2.78839 50.6906 1.16183V0H54.9831V3.60167H58.6461V7.37762H54.9831V13.4482C54.9831 15.0747 55.8417 15.859 57.6445 15.859C57.9021 15.859 58.2455 15.8299 58.6461 15.7718V19.4607C58.0738 19.5478 57.3011 19.6349 56.6429 19.6349Z",
    fill: "url(#paint7_linear_3406_6502)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5274 19.8092C62.5766 19.8092 59.3715 16.0913 59.3715 11.5021C59.3715 6.76761 62.777 3.25307 67.2412 3.25307C72.192 3.25307 74.9678 6.68047 74.9678 11.0664C74.9678 11.7054 74.9106 12.3153 74.7675 12.751H63.8358C64.0933 14.7552 65.467 16.0332 67.5846 16.0332C69.1013 16.0332 70.2174 15.3652 70.8184 14.2905L74.2524 15.9461C73.308 18.2697 70.7325 19.8092 67.5274 19.8092ZM67.2412 6.73856C65.5528 6.73856 64.3223 7.72612 63.9216 9.556H70.4177C70.246 7.87135 69.0155 6.73856 67.2412 6.73856Z",
    fill: "url(#paint8_linear_3406_6502)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4752 19.8092C78.0984 19.8092 76.0093 18.0955 76.0093 15.2199C76.0093 12.5477 77.8122 10.7469 81.5611 10.1369L85.8822 9.43982V9.00413C85.8822 7.81325 84.8806 6.88379 83.2781 6.88379C81.7328 6.88379 80.5022 7.81325 79.9871 9.20745L76.5531 7.55184C77.4688 4.90868 80.1588 3.25307 83.4784 3.25307C87.4275 3.25307 90.1748 5.60578 90.1748 9.00413V19.4606H86.1684V17.9793C84.9379 19.2282 83.4498 19.8092 81.4752 19.8092ZM80.445 15.0747C80.445 16.0623 81.2463 16.6141 82.3337 16.6141C84.4514 16.6141 85.8822 15.0747 85.8822 13.1286V12.6348L82.3337 13.2739C81.1032 13.5062 80.445 14.029 80.445 15.0747Z",
    fill: "url(#paint9_linear_3406_6502)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2479 19.4566V3.5976H96.2542V5.54366C97.0555 3.97519 98.6581 3.24905 100.633 3.24905C102.693 3.24905 104.496 4.17851 105.383 5.68889C106.499 4.03328 108.188 3.24905 110.219 3.24905C113.596 3.24905 116 5.65984 116 9.26152V19.4566H111.707V10.191C111.707 8.3611 110.677 7.17022 108.989 7.17022C107.3 7.17022 106.27 8.3611 106.27 10.191V19.4566H101.978V10.191C101.978 8.3611 100.947 7.17022 99.259 7.17022C97.5706 7.17022 96.5404 8.3611 96.5404 10.191V19.4566H92.2479Z",
    fill: "url(#paint10_linear_3406_6502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3406_6502",
    x1: 58.0327,
    y1: -8.51108,
    x2: 65.9742,
    y2: 26.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A54CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000E3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAteamLogo);
export default __webpack_public_path__ + "static/media/ateam-logo.2c5a0f6e.svg";
export { ForwardRef as ReactComponent };